import React from 'react';
import Container from 'react-bootstrap/Container';

const Genrateinvoice = () => {
  return (
    <div>
        <Container>             
        <div className='container'>
            <div className='row '>
                <div className='col-lg-12 '>
                    <div className='row ' style={{display:"flex"}} >
                    </div>
                    <div className="row ">
                        <div className="col-lg-6 mt-4  ">
                        </div>
                    </div>
                    <div className="row mt-4">
                    <div className="col-lg-12">
                        <div className="card">
                        <div className="card-header"  style={{backgroundColor:"rgb(0,156,216)",color:'white'}}>
                            <h4> Invoice </h4>
                        </div>
                        <div className="card-body">
                            <form>
                            <div className="card-body">
                                <h5>User Information: <br />
                                    Melody <br />
                                    xyz <br />
                                   Bangalore <br />
                                    560078</h5>
                                    <h4>12-09-2023</h4>
                                    <h5 className='mt-5'>WDM: <br />
                                         Cell No: +91 123456789 <br />
                                           Email: info@gmail.com <br />
                                           City : Bangalore </h5>
                                <div className='table-responsive mt-3'>
                                <table className="table table-bordered">
                                <thead>
                                    <tr>
                                    <th scope="col">Sl No</th>
                                    <th scope="col">Product Name</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Cost</th>
                                    <th scope="col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    <tr>
                                    <th scope="row">1</th>
                                    <td>Hi123</td>
                                    <td>Shirt</td>
                                    <td>3</td>
                                    <td>₹13,967</td>
                                    <td>13,967</td>
                                    </tr>

                                    <tr>
                                    <th scope="row">2</th>
                                    <td>Hi123</td>
                                    <td>Shirt</td>
                                    <td>3</td>
                                    <td>₹13,967</td>
                                    <td>13,967</td>
                                    
                                    </tr>
                                    <tr>
                                    <th scope="row">2</th>
                                    <td>Hi123</td>
                                    <td>Shirt</td>
                                    <td>3</td>
                                    <td>₹13,967</td>
                                    <td>13,967</td>
                                    </tr>

                                    <tr>
                                    <th colSpan="3">Total</th>
                                    
                                    <td colSpan="3">SUB TOTAL : <span>300.0</span></td>
                                    </tr>

                                </tbody>

                                <h2 className='mt-4'>GRAND TOTAL  : 3000</h2>
                                </table>

                                </div>
                            </div>
                            {/* /.card-body */}
                            </form>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </Container>
    </div>
  )
}

export default Genrateinvoice;